import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

// The state for requesting an update on MobilityStore's reports table
export const STATE_REPORT_UPDATING = atom<boolean>({
    key: "ms-state-report-updating",
    default: false
});

// The state for requesting an update on MobilityStore's printouts table
export const STATE_PRINTOUT_UPDATING = atom<boolean>({
    key: "ms-state-printout-updating",
    default: false
});

// The state of active filters on MobilityStore's reports page
export const STATE_REPORT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'ms-state-report-active-filters',
    default: []
});

// The state of active filters on MobilityStore's printouts page
export const STATE_PRINTOUT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'ms-state-printout-active-filters',
    default: []
});

// The state of active filters on MobilityStore's single printouts page
export const STATE_SINGLE_PRINTOUT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'ms-state-single-printout-active-filters',
    default: []
});

export const STATE_REPORT_TOTAL_COUNT = atom<any>({
    key: 'ms-state-report-total-count',
    default: null
});

export const STATE_PRINTOUT_TOTAL_COUNT = atom<any>({
    key: 'ms-state-printout-total-count',
    default: null
});

export const STATE_DISABLE_TAB = atom<boolean>({
    key: "mobility-state-tab-disable",
    default: false
});